import { DependencyList, EffectCallback, useEffect, useState } from "react"
import { isEqual } from "lodash"

export const useDeepCompareEffect = (
  callback: EffectCallback,
  dependencies: DependencyList,
): void => {
  const [currentDependencies, setCurrentDependencies] = useState<DependencyList>(dependencies)

  const dependenciesChanged = !isEqual(currentDependencies, dependencies)

  useEffect(() => {
    if (dependenciesChanged) {
      setCurrentDependencies(dependencies)
      callback()
    }
  }, [dependencies, dependenciesChanged, callback])
}
